<css-loading-indicator [show]="pdpLoad"></css-loading-indicator>
<div class="container container__body" *ngIf="singleProductData">
    <ul class="breadcrumbs" itemscope="" itemtype="http://schema.org/BreadcrumbList">
        <li class="breadcrumb">
            <a (click)='loadBreadCrumbPage("/", "home")' class="breadcrumb-label"><span kuiText>Home</span></a>
        </li>
        <li class="breadcrumb">
            <a href="/{{locale}}/geforce/store/?page=1&limit=9&locale={{locale}}&category={{singleProductData.category}}"
                class="breadcrumb-label" itemProp="item">
                <span kuiText itemProp="name">{{singleProductData.category | translate}}</span>
            </a>
        </li>
        <li class="breadcrumb ">
            <a href="/{{locale}}/geforce/store/?page=1&limit=9&locale={{locale}}&gpu={{singleProductData.gpu}}"
                class="breadcrumb-label" itemProp="item"><span kuiText itemProp="name">{{singleProductData.gpu}}</span></a>
        </li>
        <li class="breadcrumb is-active"> {{singleProductData.productTitle}} </li>
    </ul>
    <div itemscope="" itemtype="http://schema.org/Product">
        <div class="productView">
            <div class="productView-details--mobile">
                <h1 kuiText class="productView-title" itemprop="name">{{singleProductData.productTitle}}</h1>
                <div data-content-region="product_below_price"></div>
                <div class="productView__sku-review-wrapper">
                    <dl class="productView-info productView__sku-wrapper">
                        <dt kuiText class="productView-info-name sku-label">MPN:</dt>
                        <dd kuiText class="productView-info-value sku-value" data-product-sku="">
                            {{singleProductData.productSKU}}
                        </dd>
                    </dl>
                    <span class="wrapper">
                        <div class="box">
                            <p class="wrapperTooltip icon">
                                <svg viewBox="0 0 12 12" id="icon-info">
                                <path d="M7.42857 9.48204C7.42857 9.61262 7.32701 9.71418 7.19643 9.71418H3.94643C3.81585 9.71418 3.71429 9.61262 3.71429 9.48204V8.32132C3.71429 8.19074 3.81585 8.08918 3.94643 8.08918H4.64286V5.76775H3.94643C3.81585 5.76775 3.71429 5.66619 3.71429 5.53561V4.3749C3.71429 4.24432 3.81585 4.14275 3.94643 4.14275H6.26786C6.39844 4.14275 6.5 4.24432 6.5 4.3749V8.08918H7.19643C7.32701 8.08918 7.42857 8.19074 7.42857 8.32132V9.48204ZM6.5 2.98204C6.5 3.11262 6.39844 3.21418 6.26786 3.21418H4.875C4.74442 3.21418 4.64286 3.11262 4.64286 2.98204V1.82132C4.64286 1.69074 4.74442 1.58918 4.875 1.58918H6.26786C6.39844 1.58918 6.5 1.69074 6.5 1.82132V2.98204ZM11.1429 5.9999C11.1429 2.924 8.64732 0.428467 5.57143 0.428467C2.49554 0.428467 0 2.924 0 5.9999C0 9.07579 2.49554 11.5713 5.57143 11.5713C8.64732 11.5713 11.1429 9.07579 11.1429 5.9999Z">
                                </path>
                                </svg>
                                <span kuiText>This product is fulfilled by {{singleProductData?.manufacturer}}. Please note order data will be shared
                                    with {{singleProductData?.manufacturer}} for the shipping process.</span>
                            </p>   
                        </div>
                    </span>
                </div>
            </div>
            <section class="productView-images" data-image-gallery="">
                <div class="productView-images__wrapper">
                    <figure class="productView-image" data-image-gallery-main=""
                        data-zoom-image="{{singleProductData.imageURL}}">
                        <div class="productView-img-container">
                            <a target="_blank" rel="noopener" href="{{singleProductData.imageURL}}" data-index="0"
                                data-type="image">
                                <img class="productView-image--default lazyautosizes lazyloaded" data-sizes="auto"
                                    src="{{singleProductData.imageURL}}" data-src="{{singleProductData.imageURL}}"
                                    alt="ASUS TUF-RTX4090-O24G-GAMING" title="{{singleProductData.displayName}}"
                                    data-main-image="" sizes="500px">
                            </a>
                        </div>
                    </figure>
                    <div class="product__thumbnails-container" *ngIf="false">
                        <ul class="productView-thumbnails">
                            <li class="productView-thumbnail">
                                <a class="productView-thumbnail-link" href="{{singleProductData.imageURL}}"
                                    data-image-gallery-item="" data-index="0" data-type="image"
                                    data-image-gallery-new-image-url="{{singleProductData.imageURL}}"
                                    data-image-gallery-zoom-image-url="{{singleProductData.imageURL}}">
                                    <img class="lazyautosizes lazyloaded" data-sizes="auto"
                                        src="{{singleProductData.imageURL}}" data-src="{{singleProductData.imageURL}}"
                                        alt="{{singleProductData.displayName}}"
                                        title="{{singleProductData.displayName}}" sizes="50px">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
            <div class="productView__price-cart-wrappper--mobile">
                <div class="productView-price">
                    <div class="price-section price-section--withoutTax">
                        <span kuiText data-product-rrp-price-without-tax="" class="price price--rrp rrp-price--withoutTax">
                        </span>
                        <!-- Added logic -->
                        <span kuiText data-product-price-without-tax="" class="price price--withoutTax"
                            [innerHtml]="formatNumber(singleProductData.salePrice)"></span>
                    </div>
                    <div class="price-section price-section--withoutTax" itemprop="offers" itemscope=""
                        itemtype="http://schema.org/Offer">
                        <meta itemprop="availability" itemtype="http://schema.org/ItemAvailability"
                            content="http://schema.org/InStock">
                        <meta itemprop="itemCondition" itemtype="http://schema.org/OfferItemCondition"
                            content="http://schema.org/Condition">
                        <div itemprop="priceSpecification" itemscope="" itemtype="http://schema.org/PriceSpecification">
                            <meta itemprop="price" content="1799.99">
                            <meta itemprop="priceCurrency" content="USD">
                            <meta itemprop="valueAddedTaxIncluded" content="false">
                        </div>
                    </div>
                </div>
            </div>
            <section class="productView-details">
                <div class="productView-product">
                    <div class="prodView--desktop">
                        <h1 kuiText class="productView-title" itemprop="name">{{singleProductData.productTitle}}</h1>
                        <div data-content-region="product_below_price"></div>
                        <div class="productView__sku-review-wrapper">
                            <span class="productView-info productView__sku-wrapper">
                                <dt kuiText class="productView-info-name sku-label">MPN:</dt>
                                <dd kuiText class="productView-info-value sku-value" data-product-sku="">
                                    {{singleProductData.productSKU}}
                                </dd>
                            </span>
                            <!-- <span class="icon ctaTooltip">
                                <svg viewBox="0 0 12 12" id="icon-info">
                                    <path
                                        d="M7.42857 9.48204C7.42857 9.61262 7.32701 9.71418 7.19643 9.71418H3.94643C3.81585 9.71418 3.71429 9.61262 3.71429 9.48204V8.32132C3.71429 8.19074 3.81585 8.08918 3.94643 8.08918H4.64286V5.76775H3.94643C3.81585 5.76775 3.71429 5.66619 3.71429 5.53561V4.3749C3.71429 4.24432 3.81585 4.14275 3.94643 4.14275H6.26786C6.39844 4.14275 6.5 4.24432 6.5 4.3749V8.08918H7.19643C7.32701 8.08918 7.42857 8.19074 7.42857 8.32132V9.48204ZM6.5 2.98204C6.5 3.11262 6.39844 3.21418 6.26786 3.21418H4.875C4.74442 3.21418 4.64286 3.11262 4.64286 2.98204V1.82132C4.64286 1.69074 4.74442 1.58918 4.875 1.58918H6.26786C6.39844 1.58918 6.5 1.69074 6.5 1.82132V2.98204ZM11.1429 5.9999C11.1429 2.924 8.64732 0.428467 5.57143 0.428467C2.49554 0.428467 0 2.924 0 5.9999C0 9.07579 2.49554 11.5713 5.57143 11.5713C8.64732 11.5713 11.1429 9.07579 11.1429 5.9999Z">
                                    </path>
                                </svg>
                                <span class="ctaTooltipText">
                                    This product is fulfilled by Asus. Please note order data will be shared with Asus
                                    for the shipping process.
                                </span>
                            </span> -->
                            <span class="wrapper">
                                <div class="box">
                                    <p class="wrapperTooltip icon">
                                        <svg viewBox="0 0 12 12" id="icon-info">
                                        <path d="M7.42857 9.48204C7.42857 9.61262 7.32701 9.71418 7.19643 9.71418H3.94643C3.81585 9.71418 3.71429 9.61262 3.71429 9.48204V8.32132C3.71429 8.19074 3.81585 8.08918 3.94643 8.08918H4.64286V5.76775H3.94643C3.81585 5.76775 3.71429 5.66619 3.71429 5.53561V4.3749C3.71429 4.24432 3.81585 4.14275 3.94643 4.14275H6.26786C6.39844 4.14275 6.5 4.24432 6.5 4.3749V8.08918H7.19643C7.32701 8.08918 7.42857 8.19074 7.42857 8.32132V9.48204ZM6.5 2.98204C6.5 3.11262 6.39844 3.21418 6.26786 3.21418H4.875C4.74442 3.21418 4.64286 3.11262 4.64286 2.98204V1.82132C4.64286 1.69074 4.74442 1.58918 4.875 1.58918H6.26786C6.39844 1.58918 6.5 1.69074 6.5 1.82132V2.98204ZM11.1429 5.9999C11.1429 2.924 8.64732 0.428467 5.57143 0.428467C2.49554 0.428467 0 2.924 0 5.9999C0 9.07579 2.49554 11.5713 5.57143 11.5713C8.64732 11.5713 11.1429 9.07579 11.1429 5.9999Z">
                                        </path>
                                        </svg>
                                        <span kuiText *ngIf="isAsus;else pny_content">This product is fulfilled by {{singleProductData?.manufacturer}}. Please
                                            note order data will be shared
                                            with {{singleProductData?.manufacturer}} for the shipping process.</span>
                                        <ng-template #pny_content>
                                        <span kuiText>This product is fulfilled by {{singleProductData?.manufacturer}}. Please note order data will be shared
                                            with {{singleProductData?.manufacturer}} for the shipping process.</span>
                                         </ng-template>
                                    </p>   
                                </div>
                            </span>
                        </div>
                        <div class="productView__price-cart-wrapper">
                            <div class="productView-price">
                                <div class="price-section price-section--withoutTax 10">
                                    <span kuiText data-product-rrp-price-without-tax=""
                                        class="price price--rrp rrp-price--withoutTax"></span>
                                    <!-- <span data-product-price-without-tax="" class="price price--withoutTax"
                                        [innerHtml]="singleProductData.salePrice">
                                    </span> -->
                                    <span kuiText data-product-price-without-tax="" class="price price--withoutTax"
                                        [innerHtml]="formatNumber(singleProductData.salePrice)">
                                        <!-- ${{singleProductData.salePrice}} -->
                                    </span>

                                </div>
                                <div class="price-section price-section--withoutTax" itemprop="offers" itemscope=""
                                    itemtype="http://schema.org/Offer">
                                    <meta itemprop="availability" itemtype="http://schema.org/ItemAvailability"
                                        content="http://schema.org/InStock">
                                    <meta itemprop="itemCondition" itemtype="http://schema.org/OfferItemCondition"
                                        content="http://schema.org/Condition">
                                    <div itemprop="priceSpecification" itemscope=""
                                        itemtype="http://schema.org/PriceSpecification">
                                        <meta itemprop="price" content="1799.99">
                                        <meta itemprop="priceCurrency" content="USD">
                                        <meta itemprop="valueAddedTaxIncluded" content="false">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <dl class="productView-info productView-info-detail">
                        <div class="clearfix productSpecs" *ngFor="let specs of singleProductData.productInfo">
                            <dt kuiText class="productView-info-name">{{ specs.name | translate }} :</dt>
                            <dd kuiText class="productView-info-value">{{specs.value}}</dd>
                        </div>
                    </dl>
                </div>
            </section>

            <section class="productView-details productView-details--product-options">
                <div class="productView-options">
                    <div class="form">
                        <input type="hidden" name="action" value="add">
                        <input type="hidden" name="product_id" value="2933">
                        <div data-product-option-change="" style="">
                        </div>
                        <div class="atc-container">
                            <div class="quantityContainer">
                                <label class="form-label form-label--alternate productView__form-label"
                                    for="qty[]">Quantity</label>
                                <div class="form-field form-field--increments">
                                    <div class="form-increment productView__form-increment" data-quantity-change="">
                                        <div class="productView__quantity--buttons-wrapper">
                                            <button (click)="decreaseQuantity(prodItemval)" data-action="dec"
                                                class="button button--icon productView__quantity--button productView__quantity--button-bottom">
                                                <span class="is-srOnly"></span>
                                                <i class="icon productView__icon--arrow icon-caret-down"
                                                    aria-hidden="true">
                                                    <svg viewBox="0 0 320 512" id="icon-caret-down">
                                                        <path
                                                            d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z">
                                                        </path>
                                                    </svg>
                                                </i>
                                            </button>
                                        </div>
                                        <input oninput="if(!this.value.match('^[1-2]{1}$'))this.value='1';"
                                            class="form-input form-input--incrementTotal productView__quantity--input"
                                            readonly id="qty[]" name="qty[]" value={{prodItemval}} data-quantity-min="0"
                                            data-quantity-max="0" max="2" min="1" pattern="[1-2]{1}" aria-live="polite"
                                            #prodItemQuantity>
                                        <div class="productView__quantity--buttons-wrapper">
                                            <button class="button button--icon productView__quantity--button"
                                                (click)="increaseQuantity(prodItemval)" data-action="inc">
                                                <span class="is-srOnly"></span>
                                                <i class="icon productView__icon--arrow icon-caret-up"
                                                    aria-hidden="true">
                                                    <svg viewBox="0 0 320 512" id="icon-caret-up">
                                                        <path
                                                            d="M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z">
                                                        </path>
                                                    </svg>
                                                </i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="isOOS;else templateBuy">
                                <div class="form-action prodView__atc-btn">
                                    <button class="stock-grey-out button button--primary basic__button clearfix"
                                        id="form-action-addToCart" data-wait-message="Out of Stock">
                                        <span>{{singleProductData.prdStatus|translate}}</span>
                                    </button>
                                </div>
                            </div>
                            <ng-template #templateBuy>
                                <div class="form-action prodView__atc-btn" (click)="bigCommCheckout(singleProductData)">
                                    <button
                                        class="productView__button--add-to-cart button button--primary basic__button clearfix"
                                        id="form-action-addToCart" data-wait-message="Checkout">
                                        <span>{{'add_to_cart'|translate}}</span>
                                    </button>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="alertBox productAttributes-message" style="display:none">
                        <div class="alertBox-column alertBox-icon">
                            <!-- <icon glyph="ic-success" class="icon" aria-hidden="true"><svg
                                        xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24">
                                        <path
                                            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z">
                                        </path>
                                    </svg></icon> -->
                        </div>
                        <p class="alertBox-column alertBox-message"></p>
                    </div>

                </div>
            </section>
            <section class="productView-details" *ngIf="singleProductData?.shipInfo">
                <div class="holiday-notice"><span>Holiday Notice:</span> {{singleProductData?.shipInfo}}</div>
            </section>
        </div>
        <div id="previewModal" class="modal modal--large" data-reveal="">
            <a href="#" class="modal-close" aria-label="Close" role="button">
                <span aria-hidden="true">×</span>
            </a>
            <div class="modal-content"></div>
            <div class="loadingOverlay" style="display: none;"></div>
        </div>
        <div id="fbt">
            <h2 class="fbt__heading page-heading">
                <span class="fbt__heading-text">Frequently Bought Together</span>
            </h2>
            <ul class="fbt__image-list">
                <li class="fbt__image-item isChecked" data-product-id="2933">
                    <a class="fbt__image-link" href="##">
                        <img class="fbt__image lazyload" data-sizes="auto"
                            src="https://cdn11.bigcommerce.com/s-k09cmogsdg/stencil/5c66af10-1af7-013a-a5d3-1e9f7765d8d0/e/9d4afde0-9f41-013b-16d4-2edb73685347/img/loading.svg"
                            data-src="https://cdn11.bigcommerce.com/s-k09cmogsdg/images/stencil/300x300/products/2933/3680/TUF-RTX4090-O24G-GAMING__12855.1676401119.png?c=1"
                            alt="ASUS TUF-RTX4090-O24G-GAMING" title="ASUS TUF-RTX4090-O24G-GAMING">
                    </a>
                </li>
                <li class="fbt__image-item fbt__total">
                    <p class="fbt__total-txt">Total Price: <span class="fbt__total-price" id="fbt-totalPrice"></span>
                    </p>
                    <a class="button button--primary fbt__total-button" id="fbt-addAll" href="##">
                        <span class="icon icon--shopping-cart">
                            <svg>
                                <use xlink:href="#icon-cart"></use>
                            </svg>
                        </span>
                        <span class="fbt__atc-text">Add to Cart</span>
                    </a>
                </li>
            </ul>
            <p class="fbt__helper-text">Please choose options for all selected products</p>
            <ul class="fbt__detail-list">
                <li class="fbt__detail-item isChecked " data-product-id="2933">
                    <form method="post" action="/cart.php" enctype="multipart/form-data">
                        <input type="hidden" name="action" value="add">
                        <input type="hidden" name="product_id" value="2933">
                        <input type="hidden" name="qty[]" value="1">
                        <div class="fbt__detail-field">
                            <input class="fbt__detail-checkbox form-checkbox" type="checkbox" name="fbt__mainProduct"
                                id="fbt__mainProduct" checked="">
                            <label class="fbt__detail-label form-label" for="fbt__mainProduct">
                                <span class="fbt__detail-name"><strong>This Item:</strong> ASUS
                                    TUF-RTX4090-O24G-GAMING</span>

                                <div class="price-section price-section--withoutTax rrp-price--withoutTax"
                                    style="display: none;">
                                    <span data-product-rrp-price-without-tax="" class="price price--rrp">

                                    </span>
                                </div>
                                <div class="price-section price-section--withoutTax non-sale-price--withoutTax"
                                    style="display: none;">
                                    Was:
                                    <span data-product-non-sale-price-without-tax="" class="price price--non-sale">

                                    </span>
                                </div>
                                <div class="price-section price-section--withoutTax">
                                    <span class="price-label">

                                    </span>
                                    <span class="price-now-label" style="display: none;">
                                        Now:
                                    </span>
                                    <span data-product-price-without-tax=""
                                        [innerHtml]="formatNumber(singleProductData.salePrice)"
                                        class="price price--withoutTax"></span>
                                </div>
                                <div class="price-section price-section--saving price" style="display: none;">
                                    <span class="price">(You save</span>
                                    <span data-product-price-saved="" class="price price--saving">

                                    </span>
                                    <span class="price">)</span>
                                </div>
                            </label>
                        </div>
                    </form>
                </li>
            </ul>
            <div class="loadingOverlay"></div>
        </div>
        <div data-content-region="product_below_content"></div>
        <ul class="tabs" data-tab="" role="tablist">
            <li class="tab is-active">
                <a kuiText class="tab-title" href="javascript:void(0)">Description</a>
            </li>
        </ul>
        <div class="tabs-contents">
            <div class="tab-content is-active" id="tab-description">
                <div class="longDescription" [innerHTML]="singleProductData.longDesc"></div>
            </div>
            <div kuiText class="tab-content" id="tab-documents"></div>
        </div>
    </div>
</div>
<footer></footer>